export default __webpack_public_path__ + "static/media/3.820b208b.png";